import { render, staticRenderFns } from "./TeleMarketUserStatistics.vue?vue&type=template&id=0dba3dfc&scoped=true"
import script from "./TeleMarketUserStatistics.vue?vue&type=script&lang=js"
export * from "./TeleMarketUserStatistics.vue?vue&type=script&lang=js"
import style0 from "./TeleMarketUserStatistics.vue?vue&type=style&index=0&id=0dba3dfc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dba3dfc",
  null
  
)

export default component.exports